import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from './models/types';
import { SideEffect } from "../../../../common/models/flow.dto";

@Component({
    selector: 'app-side-effect-release-financial-assurance',
    templateUrl: './side-effect-release-financial-assurance.component.html',
    styleUrls: ['./side-effect-release-financial-assurance.component.scss'],
    standalone: false
})
export class SideEffectReleaseFinancialAssuranceComponent implements OnInit, OnDestroy {

	_selectedSideEffect: SideEffect;
	_seConfiguration: any;

	get dateSources(): any[] {
		return this._seConfiguration.dateSources;
	}

	set dateSources(values: any[]) {
		this._seConfiguration.dateSources = values;
	}

	constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
		this._seConfiguration = data.configuration;
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		this.dateSources = this.dateSources.filter(d => (d.check != null && d.check.length > 0) || (d.date != null && d.date.length > 0));
	}


	add(): void {
		let newSource = { check: "", date: "" };
		this.dateSources.push(newSource);
		setTimeout(() => {
			const element = document.getElementById(`check${this.dateSources.length - 1}`);
			if (element != null) {
				element.focus();
			}
		}, 200);
	}

	delete(index: number): void {
		this.dateSources.splice(index, 1);		
		setTimeout(() => {
			const element = document.getElementById(`check${this.dateSources.length - 1}`);
			if (element != null) {
				element.focus();
			}
		}, 200);
	}
}
